/**
 * Code for picking up Azure AD info in regular files
 */
import { UofGMSALConfig } from '@/msad/authConfig'
import { PublicClientApplication } from "@azure/msal-browser"
import { InteractionRequiredAuthError } from "@azure/msal-common"

export const msalMethods = () => {
    let msalInstance
    let inited = false

    const initMsal = async () => {
        console.log('*** initMsal called ***')
        const msalConfig = UofGMSALConfig
        msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig)
        console.log('msalInstance is now ')
        console.log(msalInstance)
        inited = true    
    }

    const catchRedirect = async () => {
        if (!inited) {
            console.log('getAccount: need to initialise')
            await initMsal()
        }
        const tokenResponse = await msalInstance.handleRedirectPromise()
        return tokenResponse
    }
    const startRedirect = async () => {
        if (!inited) {
            console.log('getAccount: need to initialise')
            await initMsal()
        }

        try {
            msalInstance.loginRedirect({})
        } catch (err) {
            console.error('ERROR with MSAD login...')
            console.log(err)
        }
    }

    const getAccount = async () => {
        if (!inited) {
            console.log('getAccount: need to initialise')
            await initMsal()
        }
        const account = msalInstance.getAllAccounts()[0]
        return account
    }

    const getToken = async (accountObj) => {
        if (!inited) {
            console.log('getToken: need to initialise')
            await initMsal()
        }

        if (typeof accountObj === 'undefined') {
            console.log('getToken not provided with an account - using account in msalInstance')
        }
        const lkupAccount = typeof accountObj !== 'undefined' ? accountObj : msalInstance.getAllAccounts()[0]
        let tokenResponse
        try {
            tokenResponse = await msalInstance.acquireTokenSilent({
                account: lkupAccount,
                scopes: ["User.Read"] // TODO: put in config (unless we need to check different scopes??)
            })    
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                tokenResponse = await msalInstance.acquireTokenRedirect(request)
                console.error('fellback to interactive method')
                console.log(tokenResponse)
            }  
        }
        // console.log(tokenResponse)
        // Do something with the tokenResponse
        return tokenResponse.accessToken
    }

    return {
        getAccount,
        getToken,
        startRedirect,
        catchRedirect
    }
}